// extracted by mini-css-extract-plugin
export default {"minimal":"minimal_minimal__hRuFy"};